"use client";

import {
  Flex,
  Image,
  Separator,
  Text,
  Heading,
  Link,
  Alert,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";

import NavigationTitleAndControls from "@features/marketplace/navigation/NavigationTitleAndControls";
import TopBar from "@features/marketplace/navigation/TopBar";
import { toPxString } from "helpers/styles";
import { useInitCart } from "hooks/useGetCart";

const NAVIGATION_TITLE_SECTION_HEIGHT = 32;

const AboutAnabelRose = () => {
  const onClickImage = useCallback(() => {
    window.open("https://anabelrose.com", "_blank");
  }, []);

  return (
    <Flex gap={4}>
      <Image
        src="/images/saar-anabel-rose-min.png"
        alt="Something About A Rose"
        h="300px"
        fit="contain"
        cursor="pointer"
        onClick={onClickImage}
      />
      <Flex flexDirection="column" gap={2} pt={10} justifyContent="flex-start">
        <Text maxW="sm" fontSize="sm">
          Anabel Rose, a Filipino-Ghanaian alt-pop artist, is on a journey of
          sonic exploration marked by unapologetic freedom. Every purchase goes
          towards furthering the dreams of her artistry
        </Text>
      </Flex>
    </Flex>
  );
};

const Contact = () => {
  return (
    <Flex flexDirection="column" gap={2}>
      <Heading>Contact</Heading>
      <Text>theanabelrose@gmail.com</Text>
    </Flex>
  );
};

const Socials = () => {
  return (
    <Flex flexDirection="column" gap={2}>
      <Heading>Socials</Heading>
      <Flex flexDirection="column" gap={2}>
        <Link
          target="_blank"
          href="https://open.spotify.com/artist/3eVgQnpc2p4D7ora60WBKb?si=Zp6KrlIcTpe94csiqNAefQ"
        >
          Spotify
        </Link>
        <Link target="_blank" href="https://www.instagram.com/theanabelrose">
          Instagram
        </Link>
        <Link target="_blank" href="https://x.com/theanabelrose">
          X
        </Link>
        <Link target="_blank" href="https://www.tiktok.com/@theanabelrose ">
          TikTok
        </Link>
        <Link target="_blank" href="https://www.youtube.com/@theanabelrose">
          YouTube
        </Link>
      </Flex>
    </Flex>
  );
};

const Footer = () => {
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      px={10}
      flexWrap="wrap"
      gap={4}
      pb={10}
    >
      <AboutAnabelRose />
      <Contact />
      <Socials />
    </Flex>
  );
};

const MarketplaceLayout = ({ children }: { children: React.ReactNode }) => {
  useInitCart();

  return (
    <Flex
      flexDirection="column"
      flex={1}
      bg="sidebar.background"
      height="100dvh"
      pb={2}
      px={2}
    >
      <TopBar />
      <Flex
        flexDirection="column"
        flex={1}
        gap={2}
        bg="surface.background"
        p={2}
      >
        <Flex
          position="sticky"
          top={0}
          w="full"
          zIndex="sticky"
          bg="surface.background"
          height={toPxString(NAVIGATION_TITLE_SECTION_HEIGHT)}
          borderRadius="md"
          alignItems="center"
        >
          <NavigationTitleAndControls />
        </Flex>
        <Flex flexDirection="row" flex={1} gap={2}>
          <Flex w="full" h="full" flexDirection="column" gap={2}>
            {children}
          </Flex>
        </Flex>
      </Flex>
      <Separator my={4} />
      <Footer />
    </Flex>
  );
};

export default observer(MarketplaceLayout);
